import {MiniCartGateway} from "../classes";
import cart from '@ppcp/cart';
import Actions from '@ppcp/actions';

class PaypalMinicart extends MiniCartGateway {

}

new PaypalMinicart(cart, {id: 'ppcp', actions: new Actions(), context: 'cart'});